// import { globalPut } from '../index';
import { post } from "../index";

export const uploadCsv = body => {
  console.log(body)
  return post('/statuses/csv', body, true);
}
